import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  Typography,
  Box,
  Card,
  CardContent,
} from "@mui/material";
import CarIcon from "@mui/icons-material/DirectionsCar";
import PersonIcon from "@mui/icons-material/Person";
import { format } from "date-fns";

const DetalleConductor = ({ selectedConductor, handleDetailClose }) => {
  return (
    <Dialog open={!!selectedConductor} onClose={handleDetailClose} fullWidth maxWidth="sm">
      <DialogContent dividers sx={{ padding: "20px", backgroundColor: "#f4f6f9" }}>
        {selectedConductor ? (
          <Box>
            {/* Conductor Info */}
            <Card sx={{ marginBottom: 2, boxShadow: 3, borderRadius: "8px" }}>
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    marginBottom: 2,
                    fontWeight: "bold",
                    color: "#152d51",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <PersonIcon sx={{ marginRight: 1, color: "#152d51" }} />
                  {selectedConductor.nombre} {selectedConductor.apellido}
                </Typography>

                <Typography variant="subtitle1"><strong>Número de Licencia:</strong> {selectedConductor.numero_licencia || "N/A"}</Typography>
                <Typography variant="subtitle1"><strong>Categoría Licencia:</strong> {selectedConductor.categoria_licencia || "N/A"}</Typography>
                <Typography variant="subtitle1">
                  <strong>Vencimiento Licencia:</strong> {selectedConductor.vencimiento_licencia ? format(new Date(selectedConductor.vencimiento_licencia), 'dd/MM/yyyy') : "N/A"}
                </Typography>
                <Typography variant="subtitle1"><strong>Área:</strong> {selectedConductor.area || "N/A"}</Typography>
                <Typography variant="subtitle1"><strong>PIN:</strong> {selectedConductor.pin || "N/A"}</Typography>
                <Typography variant="subtitle1"><strong>Teléfono:</strong> {selectedConductor.telefono || "N/A"}</Typography>
                <Typography variant="subtitle1"><strong>Email:</strong> {selectedConductor.email || "N/A"}</Typography>
              </CardContent>
            </Card>

            {selectedConductor.licencia && (
              <Card sx={{ marginBottom: 2, boxShadow: 3, borderRadius: "8px" }}>
                <CardContent>
                  <Typography
                    variant="h6"
                    sx={{
                      marginBottom: 2,
                      fontWeight: "bold",
                      color: "#152d51",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Licencia
                  </Typography>

                  <Typography variant="body1">
                    <strong>Licencia (Archivo):</strong>{" "}
                    <a
                      href={selectedConductor.licencia}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#1976d2" }}
                    >
                      Ver archivo
                    </a>
                  </Typography>

                  <Typography variant="body1" sx={{ marginTop: 1 }}>
                    <strong>Observaciones:</strong> {selectedConductor.observaciones || "N/A"}
                  </Typography>
                </CardContent>
              </Card>
            )}

            {/* Vehículos Asignados */}
            {selectedConductor.vehiculos_objetos?.length > 0 ? (
              selectedConductor.vehiculos_objetos.map((vehiculo, index) => (
                <Card key={vehiculo.id || index} sx={{ marginBottom: 2, boxShadow: 3, borderRadius: "8px" }}>
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{
                        marginBottom: 2,
                        fontWeight: "bold",
                        color: "#152d51",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <CarIcon sx={{ marginRight: 1, color: "#152d51" }} />
                      Vehículo Asignado
                    </Typography>
                    <Typography variant="body1"><strong>Dominio:</strong> {vehiculo.patente}</Typography>
                    <Typography variant="body1"><strong>Marca:</strong> {vehiculo.marca}</Typography>
                    <Typography variant="body1"><strong>Modelo:</strong> {vehiculo.modelo}</Typography>
                  </CardContent>
                </Card>
              ))
            ) : (
              <Typography variant="body2" color="textSecondary">
                <strong>No hay vehículos asignados.</strong>
              </Typography>
            )}
          </Box>
        ) : (
          <Typography variant="body2" color="textSecondary">
            No se encontraron detalles del conductor.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: "16px", backgroundColor: "#f4f6f9" }}>
        <Button onClick={handleDetailClose} variant="contained" sx={{ backgroundColor: "#152d51" }} fullWidth>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DetalleConductor;
